// Persian (Farsi) translations
export const fa: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'داشبورد',
  'menu.orderNew': 'ثبت محصول',
  'menu.deliveryList': 'لیست تحویل',
  'menu.delivery': 'تحویل',
  'menu.receipt': 'چاپ رسید/برچسب',
  'menu.definitions': 'تعاریف',
  'menu.customers': 'مشتریان',
  'menu.products': 'تعاریف محصولات',
  'menu.pricing': 'تعاریف قیمت',
  'menu.tailoring': 'عملیات خیاطی',
  'menu.attributes': 'ویژگی‌های محصول',
  'menu.users': 'کاربران',
  'menu.productOrdering': 'ترتیب محصولات',
  'menu.discounts': 'تعاریف تخفیف',
  'menu.settings': 'تنظیمات',
  'menu.generalSettings': 'تنظیمات عمومی',
  'menu.permissions': 'مدیریت مجوزها',
  'menu.subscription': 'اشتراک',
  'menu.invoices': 'مدیریت فاکتورها',
  'menu.expenses': 'ورود هزینه‌ها',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'گزارش‌ها و حسابداری',
  'menu.systemAndCommunication': 'سیستم و ارتباطات',
  'menu.reportsList': 'لیست رسیدها',
  'menu.accountStatement': 'صورتحساب',
  'menu.tickets': 'درخواست‌های پشتیبانی',
  'menu.support': 'پشتیبانی',
  'menu.profile': 'پروفایل',
  'menu.logout': 'خروج',
  'menu.notifications': 'اعلان‌های پیامک/واتساپ',
  'menu.whatsappConnection': 'اتصال واتساپ',
  'menu.smsConnection': 'اتصال پیامک',
  
  // Dashboard
  'dashboard.title': 'داشبورد',
  'dashboard.todaySales': 'فروش امروز',
  'dashboard.totalOrders': 'کل سفارشات',
  'dashboard.pendingDeliveries': 'تحویل‌های در انتظار',
  'dashboard.activeCustomers': 'مشتریان فعال',
  'dashboard.recentOrders': 'سفارشات اخیر',
  'dashboard.viewAll': 'مشاهده همه',
  'dashboard.quickActions': 'اقدامات سریع',
  'dashboard.newOrder': 'سفارش جدید',
  'dashboard.newCustomer': 'مشتری جدید',
  'dashboard.deliveries': 'تحویل‌ها',
  'dashboard.reports': 'گزارش‌ها',
  'dashboard.today': 'امروز',
  'dashboard.yesterday': 'دیروز',
  'dashboard.week': 'هفته',
  'dashboard.month': 'ماه',
  'dashboard.quarter': 'فصل',
  'dashboard.year': 'سال',
  'dashboard.totalRevenue': 'کل درآمد',
  'dashboard.totalOrdersCard': 'کل سفارشات',
  'dashboard.totalPieces': 'کل اقلام',
  'dashboard.cancelled': 'لغو شده',
  'dashboard.inProcess': 'در حال پردازش',
  'dashboard.inProcessDesc': 'سفارشات در حال پردازش',
  'dashboard.ready': 'آماده',
  'dashboard.readyDesc': 'سفارشات آماده تحویل',
  'dashboard.delivered': 'تحویل داده شده',
  'dashboard.deliveredDesc': 'سفارشات تکمیل شده',
  'dashboard.announcements': 'اعلانات',
  'dashboard.announcementAll': 'عمومی',
  'dashboard.announcementPrivate': 'خصوصی',
  
  // Order Entry
  'order.title': 'سفارش جدید',
  'order.customer': 'مشتری',
  'order.selectCustomer': 'انتخاب مشتری',
  'order.newCustomer': 'مشتری جدید',
  'order.products': 'محصولات',
  'order.addProduct': 'افزودن محصول',
  'order.selectProduct': 'انتخاب محصول',
  'order.quantity': 'تعداد',
  'order.price': 'قیمت',
  'order.total': 'جمع',
  'order.discount': 'تخفیف',
  'order.subtotal': 'جمع جزء',
  'order.tax': 'مالیات',
  'order.grandTotal': 'جمع کل',
  'order.payment': 'پرداخت',
  'order.paymentMethod': 'روش پرداخت',
  'order.cash': 'نقدی',
  'order.card': 'کارت اعتباری',
  'order.credit': 'نسیه',
  'order.amountPaid': 'مبلغ پرداختی',
  'order.remainingBalance': 'مانده حساب',
  'order.deliveryDate': 'تاریخ تحویل',
  'order.notes': 'یادداشت‌ها',
  'order.createOrder': 'ایجاد سفارش',
  'order.cancel': 'لغو',
  
  // Users
  'users.title': 'کاربران',
  'users.addNew': 'کاربر جدید',
  'users.name': 'نام',
  'users.email': 'ایمیل',
  'users.role': 'نقش',
  'users.pin': 'پین',
  'users.permissions': 'مجوزها',
  'users.allPermissions': 'همه مجوزها',
  'users.permissionCount': '{count} مجوز',
  'users.changePin': 'تغییر پین',
  'users.edit': 'ویرایش',
  'users.delete': 'حذف',
  'users.newUser': 'کاربر جدید',
  'users.editUser': 'ویرایش کاربر',
  'users.editingUser': 'ویرایش {name}',
  'users.deleteUserTitle': 'حذف کاربر',
  'users.deletingUser': 'آیا مطمئن هستید که می‌خواهید {name} را حذف کنید؟',
  'users.pinCode': 'کد پین (4-6 رقمی)',
  'users.selectRole': 'انتخاب نقش',
  'users.patron': 'مالک',
  'users.kasiyer': 'صندوقدار',
  'users.sofor': 'راننده',
  'users.changePinTitle': 'تغییر کد پین',
  'users.newPin': 'کد پین جدید',
  'users.confirmPin': 'تأیید کد پین',
  'users.pinMismatch': 'کدهای پین مطابقت ندارند',
  'users.pinRequired': 'کد پین الزامی است',
  'users.pinLength': 'کد پین باید 4-6 رقمی باشد',
  'users.changingPinFor': 'تغییر پین برای {name}',
  
  // Products
  'products.title': 'تعاریف محصولات',
  'products.addNew': 'محصول جدید',
  'products.category': 'دسته‌بندی',
  'products.name': 'نام محصول',
  'products.price': 'قیمت',
  'products.color': 'رنگ',
  'products.active': 'فعال',
  'products.actions': 'اقدامات',
  'products.search': 'جستجوی محصول...',
  'products.noProducts': 'محصولی یافت نشد',
  'products.noCategoryProducts': 'در این دسته محصولی وجود ندارد',
  'products.emptyCart': 'سبد خرید خالی است',
  
  // Service Types
  'service.tailor': 'خیاطی',
  'service.dryCleaning': 'خشکشویی',
  'service.washing': 'شستشو',
  'service.ironing': 'اتو',
  'service.shoeShine': 'واکس کفش',
  'service.carpet': 'فرش',
  'service.tailoring': 'اصلاح خیاطی',
  'service.carpetWashing': 'قالیشویی',
  'service.selectService': 'انتخاب سرویس',
  'service.addToCart': 'افزودن به سبد',
  'service.total': 'جمع',
  
  // Common
  'common.yes': 'بله',
  'common.no': 'خیر',
  'common.cancel': 'لغو',
  'common.confirm': 'تأیید',
  'common.delete': 'حذف',
  'common.edit': 'ویرایش',
  'common.save': 'ذخیره',
  'common.search': 'جستجو',
  'common.loading': 'در حال بارگذاری...',
  'common.noData': 'داده‌ای وجود ندارد',
  'common.actions': 'اقدامات',
  'common.status': 'وضعیت',
  'common.date': 'تاریخ',
  'common.time': 'زمان',
  'common.total': 'جمع',
  'common.filter': 'فیلتر',
  'common.export': 'خروجی',
  'common.print': 'چاپ',
  'common.close': 'بستن',
  'common.back': 'بازگشت',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'ارسال',
  'common.reset': 'بازنشانی',
  'common.create': 'ایجاد',
  'common.creating': 'در حال ایجاد...',
  'common.later': 'بعداً',
  'common.clear': 'پاک کردن',
  'common.copied': 'کپی شد!',
  'common.copyError': 'کپی ناموفق بود',
  'common.autoDetected': 'به طور خودکار شناسایی شد',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  
  // Login
  'login.title': 'کلیندی',
  'login.subtitle': 'سیستم مدیریت خشکشویی',
  'login.tenantId': 'شناسه شرکت',
  'login.tenantPlaceholder': 'شناسه-شرکت (مثال: acme-clean)',
  'login.tenantIdHelp': 'شناسه منحصر به فرد شرکت خود را وارد کنید',
  'login.continue': 'ادامه ←',
  'login.notMember': 'هنوز عضو نیستید؟',
  'login.startTrial': 'شروع دوره آزمایشی رایگان',
  'login.adminLogin': '🔒 ورود مدیر',
  'login.enterPin': 'کد پین خود را وارد کنید',
  'login.changeTenant': 'تغییر شرکت',
  'login.clear': 'پاک کردن',
  'login.delete': 'حذف',
  'login.login': 'ورود',
  'login.loggingIn': 'در حال ورود...',
  'login.defaultPinOwner': 'پین پیش‌فرض: <strong>1234</strong> (مالک)',
  'login.defaultPinCashier': 'پین پیش‌فرض: <strong>0000</strong> (صندوقدار)',
  'login.systemInitializing': 'راه‌اندازی سیستم...',
  'login.pinMinLength': 'پین باید حداقل 4 رقمی باشد',
  'login.invalidTenantId': 'شناسه شرکت معتبر وارد کنید',
  'login.tenantNotFound': 'این کد شرکت یافت نشد. بررسی کنید یا حساب جدید ایجاد کنید.',
  'login.loginFailed': 'ورود ناموفق بود',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',

  // Signup translations
  'signup.title': 'شروع دوره آزمایشی رایگان',
  'signup.subtitle': '15 روز رایگان، بدون نیاز به کارت اعتباری',
  'signup.backToLogin': 'بازگشت به صفحه ورود',
  'signup.companyCode': 'کد شرکت',
  'signup.companyCodePlaceholder': 'مثال: cleanpro',
  'signup.companyCodeHelp': 'این کد برای ورود به سیستم استفاده می‌شود',
  'signup.companyCodeMinLength': 'کد شرکت باید حداقل 3 کاراکتر باشد',
  'signup.companyName': 'نام شرکت',
  'signup.companyNamePlaceholder': 'نام شرکت شما',
  'signup.companyNameRequired': 'نام شرکت الزامی است',
  'signup.fullName': 'نام کامل',
  'signup.fullNamePlaceholder': 'نام کامل شما',
  'signup.fullNameRequired': 'نام کامل الزامی است',
  'signup.phone': 'تلفن',
  'signup.phonePlaceholder': '+98 912 345 6789',
  'signup.validPhoneRequired': 'شماره تلفن معتبر وارد کنید',
  'signup.email': 'ایمیل',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'آدرس ایمیل معتبر وارد کنید',
  'signup.createAccount': 'ایجاد حساب',
  'signup.creating': 'در حال ایجاد...',
  'signup.terms': 'با ایجاد حساب، شما با شرایط خدمات و سیاست حریم خصوصی موافقت می‌کنید.',
  'signup.success': 'ثبت‌نام موفق بود! اطلاعات ورود به ایمیل شما ارسال شد.',
  'signup.successTitle': 'ثبت‌نام موفق!',
  'signup.successMessage': 'حساب شما با موفقیت ایجاد شد.',
  'signup.emailSent': 'اطلاعات ورود به ایمیل شما ارسال شد.',
  'signup.redirecting': 'در حال انتقال به صفحه ورود...',
  'signup.startupPackageLoaded': 'بسته راه‌اندازی بارگذاری شد!',
  'signup.products': 'محصولات',
  'signup.customers': 'مشتریان',
  'signup.users': 'کاربران',
  'signup.demoDataReady': '✨ داده‌های نمایشی شما آماده است، می‌توانید فوراً شروع به استفاده کنید!',
  'signup.loginInfo': '📧 اطلاعات ورود شما',
  'signup.loginInfoSent': '💡 این اطلاعات به ایمیل شما نیز ارسال شده است',
  'signup.loginNow': 'ورود فوری ←',
};
